import { CheckoutStep } from './checkout-step';
import { UserAddress } from '../../clients/quipli-service/user/user';
import { AccountAddresses } from '../account/addresses/account-addresses';
import { useCustomer } from '../../hooks/use-customer-context';
import { StepAction } from './checkout-view';
import { Location } from '../../clients/quipli-service/location/location';
import { CheckoutSelectedAddress } from './checkout-selected-address';

export const CheckoutBilling = ({
  step,
  currentStep,
  addresses,
  setCurrentstep,
  onSelect,
  selectedAddress,
  reload,
  location,
  isSubmitting,
  showSelectedAddress = false,
}: {
  step: number;
  currentStep: StepAction;
  addresses: UserAddress[];
  setCurrentstep: (step: StepAction) => void;
  onSelect?: (address?: UserAddress) => void;
  selectedAddress?: UserAddress;
  reload?: () => Promise<void>;
  location: Location;
  isSubmitting: boolean;
  showSelectedAddress?: boolean;
}) => {
  const customer = useCustomer();

  return (
    <>
      <CheckoutStep
        title="Billing Address"
        step={step}
        contentPadding="p-0"
        isCompleted={currentStep > StepAction.Billing}
        onEdit={() => setCurrentstep(StepAction.Billing)}
        hideEdit
      >
        {currentStep >= StepAction.Billing &&
          customer &&
          (showSelectedAddress ? (
            <CheckoutSelectedAddress address={selectedAddress} />
          ) : (
            <AccountAddresses
              addresses={addresses}
              enableSelect={true}
              type="billing"
              onSelect={(value) => {
                if (isSubmitting) return;

                currentStep === StepAction.Billing && addresses.length > 0 && setCurrentstep(StepAction.Payment);
                onSelect?.(value);
              }}
              onOpenForm={() => {
                if (isSubmitting) return;

                setCurrentstep(StepAction.Billing);
              }}
              selectedAddress={selectedAddress}
              reload={reload}
              location={location}
            />
          ))}
      </CheckoutStep>
    </>
  );
};
